import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import RichText from "@default/general-components/rich-text";

/**
 * A module representing a hero-text paragraph.
 */
const ParagraphHeroText = ({ content }) => {
  /*
   *  IMPORTANT: Relies on Taxonomy terms to be flexible. Namings are:
   * Colors: red, purple
   * Sizes: standard, smaller, smallest
   * */
  const style = content.fieldTextSize?.name?.toLowerCase() || "standard";
  const sectionClassNames = classNames({
      "paragraph paragraph-hero-text": true,
      [content.fieldColor?.name.toLowerCase()]: content.fieldColor,
      [`${style}`]: true,
    }),
    colClassNames = classNames({
      "col-12": true,
      "col-lg-10": style != "standard",
      "col-lg-11": style == "standard",
    });

  return (
    <section
      className={sectionClassNames}
      data-darkmode={content.fieldDarkMode}
    >
      <div className="container">
        <div className="row">
          <div className={colClassNames}>
            <RichText
              className="hero text"
              html={content.fieldText}
              pillSelectors={["a"]}
              hyphenated={style == "standard"}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

ParagraphHeroText.propTypes = {
  /**
   * The modules content.
   */
  viewMode: PropTypes.string,
  content: PropTypes.shape({
    fieldText: PropTypes.string.isRequired,
  }).isRequired,
};

export default ParagraphHeroText;
